import { get } from 'lodash';
import createReducer from 'Store/utils/createReducer';
import { UPDATE_QUICKLOGIN_INFOS, RESET_QUICKLOGIN_INFOS } from './quickLogin.constants';
const initialState = {
  bookingId: null,
  stayId: null,
};
export const quickLogin = createReducer(initialState, {
  [UPDATE_QUICKLOGIN_INFOS](state: ReduxState, { payload }): ReduxState {
    return {
      bookingId: get(payload, 'bookingId') || null,
      stayId: get(payload, 'stayId') || null,
    };
  },

  [RESET_QUICKLOGIN_INFOS](): ReduxState {
    return initialState;
  },
});
